//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import beiLogo from '@/assets/logo/beian.png';
export default {
  name: 'app-footer',
  props: {
    copyRight: {
      type: String,
      default: "<div><span><a href=\"http://www.beian.miit.gov.cn\">\u4EACICP\u590714052628\u53F7</a></span><a target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502041751\"><img src=\"".concat(beiLogo, "\" />\u4EAC\u516C\u7F51\u5B89\u5907 11010502041751\u53F7</a></div>")
    }
  },
  data: function data() {
    return {
      envFlag: true,
      // 是否默认环境
      copyRightHtml: ''
    };
  },
  created: function created() {
    if (this.$route.query.origin == 'zn') {
      this.copyRightHtml = JSON.parse(localStorage.getItem('siteInfo')).copyright;
    }

    if (process && process.env && process.env.VUE_APP_ENV_FlAG && process.env.VUE_APP_ENV_FlAG === 'wlmq') {
      this.envFlag = false;
    } else if (process.env.VUE_APP_ENV_FlAG && process.env.VUE_APP_ENV_FlAG === 'temporary') {
      this.envFlag = true;
    } else {
      this.envFlag = true;
    }
  }
};